export default __webpack_public_path__ + "static/media/f086e28127c57eea0c1897b2b75f16ec.png";